import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Catalogue from "./Catalogue";
import Wallet from "./Wallet";
import Diary from "./Diary";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Referral from "./Referral";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/wallet" element ={<Wallet/>}/>
          <Route path="/diary" element={<Diary/>}/>
          <Route path="/catalogue" element={<Catalogue/>}/>
          <Route path="/refer" element={<Referral/>} />
        </Routes>
    </BrowserRouter>
    {/* <Referral></Referral> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
